export default __webpack_public_path__ + "media/images/react_icons/arrow-down-white-b63142b5c8053ab404da2ddaedea4538.svg";